module.exports = __webpack_public_path__ + "static/media/policy_documents_approval.2a391942.svg";